const RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY

let recaptchaLoaded = false
let recaptchaLoadingPromise = null

export function loadRecaptcha() {
  if (recaptchaLoaded) {
    return Promise.resolve()
  }

  if (recaptchaLoadingPromise) {
    return recaptchaLoadingPromise
  }

  recaptchaLoadingPromise = new Promise((resolve, reject) => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      reject(new Error('reCAPTCHA can only load in the browser'))
      return
    }

    const existingScript = document.querySelector(
      `script[src^="https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}"]`,
    )

    if (existingScript) {
      existingScript.addEventListener('load', () => {
        recaptchaLoaded = true
        resolve()
      })

      existingScript.addEventListener('error', () => {
        reject(new Error('Failed to load reCAPTCHA script'))
      })

      if (typeof window.grecaptcha !== 'undefined') {
        recaptchaLoaded = true
        resolve()
      }

      return
    }

    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`
    script.async = true
    script.defer = true

    script.onload = () => {
      recaptchaLoaded = true
      resolve()
    }

    script.onerror = () => {
      reject(new Error('Failed to load reCAPTCHA script'))
    }

    document.head.appendChild(script)
  })

  return recaptchaLoadingPromise
}

export function getRecaptchaToken(action = 'submit') {
  return new Promise((resolve, reject) => {
    if (
      typeof window === 'undefined' ||
      typeof window.grecaptcha === 'undefined'
    ) {
      reject(new Error('reCAPTCHA not loaded'))
      return
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(RECAPTCHA_SITE_KEY, { action })
        .then((token) => resolve(token))
        .catch((error) => reject(error))
    })
  })
}

export async function getLoadedRecaptchaToken(action = 'submit') {
  await loadRecaptcha()
  return getRecaptchaToken(action)
}
